module.exports = __webpack_public_path__ + "img/icon_profile_active_pc.1407bd09.svg";